import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuItem, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { ProfileServiceService } from '../../../@core/user-profile/profile-service.service';
import { ViewContainersService } from '@urbannex/view-containers';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrls: ['./admin-header.component.scss']
})
export class AdminHeaderComponent implements OnInit,AfterViewInit {
  @Input() headerTitle:string;
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;

  app:string;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [ { title: 'Profile' }, { title: 'Log out' } ];
  /**
   * 
   */
  adminMenu:NbMenuItem[] = [
    {
      title:"Store Management",
      group:true
    },
    {
      title:"Stores",
      link:"/admin/stores",
    },
    {
      title:"Catalog",
      link:"/admin/catalogs",
    },
    {
      title:"Categories",
      link:"/admin/categories",
    },
    {
      title:"Facilities",
      link:"/admin/facilities",
    },
    {
      title:"Shipping",
      link:"/admin/shipping",
    },
    {
      title:"Product Information Management",
      group:true
    },
    {
      title:"Products",
      link:"/admin/products",
    },
    {
      title:"Product Features",
      link:"/admin/features",
    },
    {
      title:"Product Configurations",
      link:"/admin/",
    },
    {
      title:"Product Features",
      link:"/admin/features",
    },
    {
      title:"Miscelaneous",
      group:true
    },
    {
      title:"Marketing",
      link:"/admin/marketing",
    },
    {
      title:"Image Management",
      link:"/admin/img",
    },
    {
      title:"Orders",
      link:"/admin/orders"
    },
    {
      title:"CRM",
      link:"/admin/crm"
    }
    
  ]

  headerMenu: NbMenuItem[] = [
    {
      title: 'Product Management',
      link: '/pms',
    },
    {
      title: 'Content Management',
      link: '/cms',
    },
    {
      title: 'Visual Editor',
      link: '/kve',
    }
  ]

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private viewContainerService:ViewContainersService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService:NbAuthService,
    private router:Router,
    private profileService:ProfileServiceService) {
      this.authService.getToken()
      .subscribe((jwtToken:NbAuthJWTToken) => {
        if(jwtToken){
          console.log(jwtToken);
        }
        if(jwtToken.isValid()){
          this.user = jwtToken.getPayload();
          console.log({baseUrl:this.profileService.getBaseUrl()});
          //console.log(this.user);
        }
      });
     }

  ngOnInit(): void {
    if(this.router.url.includes("/cms")){
      this.app = "cms"
    }else if(this.router.url.includes("/pms")){
      this.app = "pms"
    }
    console.log(this.app);
    this.menuService.onItemClick().subscribe(menuBag =>{
      //console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        console.log({title:selectedItem.title})
        //this.headerTitle = selectedItem.title;
        //if(selectedItem.parent.title)
        //console.log({selectedItem:selectedItem});
        //this.activeInputMenuItem = selectedItem.title;
      }
    })
    this.currentTheme = this.themeService.currentTheme;
    //this.headerTitle = this.viewContainerService.getHeaderTitle()? this.viewContainerService.getHeaderTitle():"No title";
    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
      this.toggleRightSidebar();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  toggleRightSidebar():boolean{
    this.sidebarService.toggle(false, 'right');
    this.layoutService.changeLayoutSize();

    return true;
  }

  navigateHome() {
    //this.menuService.navigateHome();
    return true;
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.toggleRightSidebar();
    /* this.sidebarService.toggle(true, 'right');
    this.layoutService.changeLayoutSize(); */

  }

  wasClicked(){

  }

}
